<template>
  <div>
    <form @submit.prevent="submitForm">
      <textarea
        data-cy="supportTextarea"
        class="form-control"
        rows="3"
        v-model="feedback"
        placeholder="Describe the issue"
        required
      ></textarea>
      <div class="text-end">
        <button
          type="submit"
          data-cy="contactSupportButton"
          class="btn btn-primary mt-3 fw-bold"
        >
          Contact Support <i class="bi bi-send-fill ms-1"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
export default {
  name: "SupportForm",
  data() {
    return {
      feedback: ""
    };
  },
  computed: {
    payload() {
      const url = `${import.meta.env.VITE_DEPLOY_BUCKET}/${import.meta.env.VITE_DEPLOY_PATH}`;

      let navigator = window?.navigator;

      return {
        userAgent: navigator?.userAgent,
        mobile: navigator?.userAgentData?.mobile,
        platform: navigator?.userAgentData?.platform,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        lab: import.meta.env.VITE_TITLE,
        url,
        section: url.includes("-400") ? "400" : "401",
        name: store.getters.getFullname,
        onid: store.getters.getONID,
        feedback: this.feedback
      };
    }
  },
  methods: {
    submitForm() {
      this.$emit("submitted");
      return this.axiosCall(this.payload);
    },
    async axiosCall(payload) {
      const url = "https://api.oregonstate.education/support/v1/issue";
      return axios({
        method: "POST",
        url: url,
        data: payload,
        headers: {
          Authorization: `Bearer ${store.getters.getToken}`
        }
      })
        .then((response) => {
          this.feedback = "";
          return response;
        })
        .catch((error) => {
          return error.response;
        });
    }
  }
};
</script>
